import { TeamPageTemplate } from "./template";
import { useTeamPage } from "./logic";

export const TeamPage = () : JSX.Element => {
    const props = useTeamPage();

    return (
        <TeamPageTemplate {...props}/>
    )
}